module.exports = __webpack_public_path__ + "static/media/isometrico-inicial.57a833b4.svg";